import React from 'react'
import { Modal } from 'react-bootstrap'
import { createModal, ModalResolveType, useModalAction } from '@src/lib/modal-manager'
import { GetCarRecordDetailRespBo } from '@src/domain/services/report.services'
import { fieldParse } from '@src/utils'
import _ from 'lodash'

interface CarRecordDetailProps {
  category: string;
  itemDto: GetCarRecordDetailRespBo;
}

const titleMap: { [name: string]: string } = {
  moving: '移車',
  assembly: '組裝',
  quality: '品檢',
  repair: '維修'

}

export function CarRecordDetailModalWrapper(props: CarRecordDetailProps) {
  const { resolve, remove, hide } = useModalAction()
  const { itemDto, category } = props

  const handleClose = () => {
    resolve(ModalResolveType.CLOSED)
    hide()
    remove()
  }

  return (
    <Modal dialogClassName='car-record-detail' show onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{`車輛${titleMap[category]}明細`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='table'>
          <div className='table-wrap'>
            <table className='table-content'>
              <thead>
                <tr>
                  <th>廠區</th>
                  {category !== 'moving' ? <th>工位</th> : null}
                  <th>SFX NO</th>
                  <th>引擎編號</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{itemDto.factoryDescription}</td>
                  {category !== 'moving' ? <td>{itemDto.stationDescription}</td> : null}
                  <td>{itemDto.sfxNo}</td>
                  <td>{itemDto.engineNo}</td>
                </tr>
              </tbody>
            </table>
            <table className='table-content'>
              <thead>
                <tr>
                  <th>作業員</th>
                  <th>{category !== 'moving' ? '組裝部位' : '動作'}</th>
                  <th>開始時間</th>
                  <th>結束時間</th>
                  <th>作業時間</th>
                  <th>狀態</th>
                </tr>
              </thead>
              <tbody>
                {
                  _.map(itemDto.records, (r, i) => {
                    return (
                      <tr key={i}>
                        <td>{r.employeeName}</td>
                        <td>{category !== 'moving' ? r.partName : r.action}</td>
                        <td>{fieldParse(r.startTime)}</td>
                        <td>{fieldParse(r.endTime)}</td>
                        <td>{r.duration}</td>
                        <td>{r.status}</td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export const CarRecordDetailModal = createModal(CarRecordDetailModalWrapper)
